import {useTranslation} from '@aboutyou/i18n';
import {BulletPointList, Text} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {FC} from 'react';
import {SectionWrapper} from './SectionWrapper';

export const BulletPointSection: FC<{
  label: string;
  bulletPoints: string[];
  articleNumber?: string;
}> = ({label, bulletPoints, articleNumber}) => {
  const {t} = useTranslation();
  return (
    <SectionWrapper dataTestId={`productDetailsBulletPointSection_${label}`}>
      <StyledDescriptionDetails>
        <BulletPointList>{bulletPoints}</BulletPointList>
        {articleNumber && (
          <Text
            data-testid="productDetailsArticleNumber"
            size="px14"
            color="inherit"
          >
            {t('Item no.')} {articleNumber}
          </Text>
        )}
      </StyledDescriptionDetails>
    </SectionWrapper>
  );
};

const StyledDescriptionDetails = styled.dd`
  margin-inline-start: 0;
`;
